/**
 * Simple class defining a point in space (x,y)
 * @class DataPoint
 */
export default class DataPoint {
  constructor (opts) {
    opts = opts || {};

    /** @type {Number} */
    this.x = opts.x;

    /** @type {Number} */
    this.y = opts.y;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Point.js